import React, { useState } from 'react';
import { message, Spin, Button } from 'antd';
import { t } from 'ttag';
import styled from 'styled-components';
import { DeleteOutlined, GatewayOutlined } from '@ant-design/icons';

import { checkeredBackground } from '../../styles';

// Padding + buttons width for preview
const PREVIEW_BUTTON_WIDTH = 115;

interface BaseProps {
  width: number;
  height: number;
}

const Base = styled.div`
  text-align: center;
  border-radius: 4px;
  padding: 5px 5px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  max-width: fit-content;
  max-height: fit-content;
`;

const ImgContainer = styled.div<BaseProps>`
  outline-style: solid;
  outline-color: #d9d9d9;
  outline-width: thin;
  align-self: center;
  overflow: auto;

  & > img {
    max-width: ${props => `${props.width}px`};
    max-height: ${props => `${props.height}px`};

    ${checkeredBackground}
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > button {
    min-width: ${`${PREVIEW_BUTTON_WIDTH}px`};
    margin: 5px 0px 5px 15px;
  }
`;

interface PreviewProps {
  image: string;
  width: number;
  height: number;
  enableCrop?: boolean;
  onCropClick?: () => void;
  onDelete?: () => void;
}

const Preview = ({
  image,
  width,
  height,
  enableCrop = false,
  onDelete = () => {},
  onCropClick = () => {},
}: PreviewProps) => {
  const [hasLoaded, setLoaded] = useState(false);

  const onLoad = () => {
    setLoaded(true);
  };

  const onError = () => {
    message.error(t`Unable to load image, please try again`);
    onDelete();
  };

  return (
    <Spin spinning={!hasLoaded}>
      <Base>
        <ImgContainer width={width} height={height}>
          <img
            onLoad={onLoad}
            src={image}
            alt="preview"
            onError={onError}
            style={{ verticalAlign: 'middle' }}
          />
        </ImgContainer>
        {hasLoaded && (
          <ButtonsContainer>
            <Button icon={<DeleteOutlined />} danger onClick={onDelete}>{t`Delete`}</Button>
            {enableCrop && (
              <Button icon={<GatewayOutlined />} onClick={onCropClick}>{t`Crop`}</Button>
            )}
          </ButtonsContainer>
        )}
      </Base>
    </Spin>
  );
};

export default Preview;
